module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg-gray"
  }, [_vm._m(0), _vm._v(" "), _c('special-tabs', {
    staticClass: "special-box",
    attrs: {
      "activeName": _vm.activeName,
      "tabList": _vm.tabList
    },
    on: {
      "onClick": _vm.onClick
    }
  }), _vm._v(" "), _c('special-tabs', {
    staticClass: "special-box mt20",
    attrs: {
      "activeName": _vm.activeSecondName,
      "tabList": _vm.tabListSecond
    },
    on: {
      "onClick": _vm.onClickSecond
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-content container-wrap"
  }, [(_vm.activeName != '政策解读' && _vm.activeName != '宣传文件' && _vm.activeSecondName != '风采展示' && _vm.activeSecondName != '七彩文化区') ? _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.params
    }
  }, [(_vm.activeSecondName == '星级俱乐部' || _vm.activeSecondName == '大课间推广实施单位及先进个人' || _vm.activeSecondName == '考级中心(点)') ? _c('el-form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入关键字"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeSecondName == '四好运动员' || _vm.activeSecondName == '七彩星级等级运动员') ? _c('el-form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名或身份证号"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.activeName != '政策解读' && _vm.activeName != '宣传文件' && _vm.activeSecondName != '风采展示' && _vm.activeSecondName != '七彩文化区') ? _c('el-button', {
    staticClass: "mb10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toApply
    }
  }, [_vm._v("\n              申报入口\n            ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeSecondName == '星级俱乐部' || _vm.activeSecondName == '四好运动员' || _vm.activeSecondName == '大课间推广实施单位及先进个人' || _vm.activeSecondName == '考级中心(点)' || _vm.activeSecondName == '七彩星级等级运动员') ? _c('div', {
    staticClass: "organization_content"
  }, [_c('div', {
    staticClass: "header_screen"
  }, [_c('div', {
    staticClass: "header_screen_item"
  }, [_c('div', {
    staticClass: "header_screen_item_title"
  }, [_vm._v("省份：")]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item_content"
  }, [_c('div', {
    staticClass: "header_screen_item_el",
    class: _vm.params.namekey == 0 ? 'header_screen_item_el_active' : 0,
    on: {
      "click": function($event) {
        return _vm.onSelectArea(0)
      }
    }
  }, [_vm._v("全部\n                ")]), _vm._v(" "), _vm._l((_vm.areaList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "header_screen_item_el",
      class: _vm.params.namekey == item.key ? 'header_screen_item_el_active' : 0,
      on: {
        "click": function($event) {
          return _vm.onSelectArea(item.key)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item"
  }, [_c('div', {
    staticClass: "header_screen_item_title"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item_content"
  }, _vm._l((_vm.typeData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "header_screen_item_el",
      class: _vm.params.area_type == item.key ? 'header_screen_item_el_active' : 0,
      on: {
        "click": function($event) {
          return _vm.onSelectType(item.key)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "organization_content_list"
  }, [_vm._l((_vm.list), function(item, index) {
    return (_vm.activeSecondName == '星级俱乐部') ? _c('div', {
      key: index,
      staticClass: "organization_content_list_item"
    }, [_c('div', {
      staticClass: "organization_content_list_item_left"
    }, [_c('el-image', {
      attrs: {
        "src": item.pic_url,
        "preview-src-list": [item.pic_url]
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc"
    }, [_c('div', {
      staticClass: "organization_content_list_item_title show-one-row"
    }, [_vm._v(_vm._s(item.danwei))]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts show-one-row"
    }, [_vm._v("\n                  " + _vm._s(item.province) + _vm._s(item.city) + _vm._s(item.county)), (item.bgrade) ? _c('span', [_vm._v("(" + _vm._s(item.bgrade) + ")")]) : _vm._e()]), _vm._v(" "), (item.nickname) ? _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  负责人     "), _c('span', [_vm._v(_vm._s(item.nickname) + "(" + _vm._s(item.phone) + ")")])]) : _vm._e(), _vm._v(" "), (item.contactsname) ? _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  联系人     "), _c('span', [_vm._v(_vm._s(item.contactsname) + "(" + _vm._s(item.contactsphone) + ")")])]) : _vm._e()]), _vm._v(" "), (item.clubleixing == '社会俱乐部') ? _c('div', {
      staticClass: "organization_content_list_item_tag_province"
    }, [_vm._v(_vm._s(item.clubleixing) + "\n              ")]) : _c('div', {
      staticClass: "organization_content_list_item_tag"
    }, [_vm._v(_vm._s(item.clubleixing))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return (_vm.activeSecondName == '四好运动员') ? _c('div', {
      key: index,
      staticClass: "organization_content_list_item"
    }, [(item.pic_url) ? _c('div', {
      staticClass: "organization_content_list_item_left"
    }, [_c('el-image', {
      attrs: {
        "src": item.pic_url,
        "preview-src-list": [item.pic_url]
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc"
    }, [_c('div', {
      staticClass: "organization_content_list_item_nopic_title show-one-row"
    }, [_vm._v(_vm._s(item.danwei))]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts show-one-row"
    }, [_vm._v("\n                  " + _vm._s(item.province) + _vm._s(item.city) + _vm._s(item.county)), (item.bgrade) ? _c('span', [_vm._v("(" + _vm._s(item.bgrade) + ")")]) : _vm._e()]), _vm._v(" "), (item.name) ? _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  姓名     "), _c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item.xueduan) ? _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  学段     "), _c('span', [_vm._v(_vm._s(item.xueduan))])]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return (_vm.activeSecondName == '大课间推广实施单位及先进个人') ? _c('div', {
      key: index,
      staticClass: "organization_content_list_item"
    }, [_c('div', {
      staticClass: "organization_content_list_item_left"
    }), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc"
    }, [_c('div', {
      staticClass: "organization_content_list_item_nopic_title"
    }, [_vm._v(_vm._s(item.danwei))]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts show-one-row"
    }, [_vm._v("\n                  " + _vm._s(item.province) + _vm._s(item.city) + _vm._s(item.county) + "\n                ")]), _vm._v(" "), (item.name) ? _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  联系人     "), _c('span', [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.phone) + ")")])]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return (_vm.activeSecondName == '考级中心(点)') ? _c('div', {
      key: index,
      staticClass: "organization_content_list_item"
    }, [_c('div', {
      staticClass: "organization_content_list_item_left"
    }), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc"
    }, [_c('div', {
      staticClass: "organization_content_list_item_nopic_title"
    }, [_vm._v(_vm._s(item.danwei))]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts show-one-row"
    }, [_vm._v("\n                  " + _vm._s(item.province) + _vm._s(item.city) + _vm._s(item.county) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  考官     "), _vm._l((item.kaoguan), function(member) {
      return _c('span', {
        staticStyle: {
          "margin-right": "4px"
        }
      }, [_vm._v(_vm._s(member.name))])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  监督     "), _vm._l((item.jiandu), function(member) {
      return _c('span', {
        staticStyle: {
          "margin-right": "4px"
        }
      }, [_vm._v(_vm._s(member.name))])
    })], 2)]), _vm._v(" "), (item.kaojitype == '考级中心') ? _c('div', {
      staticClass: "organization_content_list_item_tag_province"
    }, [_vm._v(_vm._s(item.kaojitype) + "\n              ")]) : _c('div', {
      staticClass: "organization_content_list_item_tag"
    }, [_vm._v(_vm._s(item.kaojitype))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return (_vm.activeSecondName == '七彩星级等级运动员') ? _c('div', {
      key: index,
      staticClass: "organization_content_list_item"
    }, [_c('div', {
      staticClass: "organization_content_list_item_left"
    }), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc"
    }, [_c('div', {
      staticClass: "organization_content_list_item_nopic_title"
    }, [_vm._v(_vm._s(item.danwei))]), _vm._v(" "), _c('div', {
      staticClass: "organization_content_list_item_desc_contacts show-one-row"
    }, [_vm._v("\n                  " + _vm._s(item.province) + _vm._s(item.city) + _vm._s(item.county) + "\n                ")]), _vm._v(" "), (item.name) ? _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  姓名     "), _c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item.grade) ? _c('div', {
      staticClass: "organization_content_list_item_desc_contacts"
    }, [_vm._v("\n                  等级     "), _c('span', [_vm._v(_vm._s(item.grade))])]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.row.totalpage > 1) ? _c('el-pagination', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "current-page": _vm.row.p,
      "page-size": _vm.row.step,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.row, "p", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.row, "p", $event)
      }
    }
  }) : _vm._e()], 2)]) : _c('div', [_vm._l((_vm.list), function(item) {
    return (_vm.list.length > 0) ? _c('div', {
      key: item.id,
      staticClass: "contactus_content_li"
    }, [_c('NewsItem', {
      attrs: {
        "row": item
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.row.totalpage > 1 && !_vm.loading) ? _c('el-pagination', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "current-page": _vm.row.p,
      "page-size": _vm.row.step,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.row, "p", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.row, "p", $event)
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.list.length === 0 && !_vm.loading) ? _c('div', {
    staticClass: "mt20"
  }, [_vm._v("\n          没有更多数据了～\n        ")]) : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner_bg"
  }, [_c('img', {
    staticClass: "banner_bg_pic",
    attrs: {
      "src": require("@/assets/images/mainindex/qcxj-club.jpeg")
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "banner_bg_desc"
  }, [_c('div', {
    staticClass: "banner_bg_desc_title"
  }, [_vm._v("啦啦操星级俱乐部")]), _vm._v(" "), _c('div', {
    staticClass: "banner_bg_desc_entitle"
  }, [_vm._v("CCA Club")])]), _vm._v(" "), _c('div', {
    staticClass: "banner_bg_desc"
  }, [_c('div', {
    staticClass: "banner_bg_desc_title"
  }, [_vm._v("啦啦操七彩星级")]), _vm._v(" "), _c('div', {
    staticClass: "banner_bg_desc_entitle"
  }, [_vm._v("Cheerleading Rainbow Stars")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a27c94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/QcxjClub.vue
// module id = 1459
// module chunks = 0